document.addEventListener("DOMContentLoaded", async () => {
  const elMainTitle = document.getElementById("main-title"),
        elYardTitle = document.getElementById("yard_title"),
        elYardBelowTitle = document.getElementById("yard_belowtitle"),
        elCollectionWrapper = document.getElementById("collections-container");

  if (!elMainTitle && !elYardTitle && !elYardBelowTitle && !elCollectionWrapper) return;

  const raw = localStorage.getItem("fabricEstimatorSelectedWidth");
  if (!raw) return;

  let data;
  try { data = JSON.parse(raw); } catch { return; }

  // Helper: if "continue" → return data.Type
  // const normalize = v => {
  //   if (v == null) return "";
  //   const s = String(v).trim().toLowerCase();
  //   if (s === "continue") return data.Type || "";
  //   return String(v).trim();
  // };
   // Normalize values + fix "continue"

  //  const normalize = v => { 
  //   if (v == null) return ""; 
  //   const s = String(v).trim(); 
  //   return s.toLowerCase() === "continue" ? "" : s; 
  //   }; 
  


  const normalize = v => {
    if (v == null) return "";
    const s = String(v).trim().toLowerCase();
    if (s === "continue") return data.Type || "";
    return String(v).trim();
  };

  

  // // SAFE replace
  // const safeReplace = (html, placeholder, value) =>
  //   html.replace(new RegExp(placeholder, "g"), value);

  // ----------------------------
  //  A / AN LOGIC FIXED HERE
  // ----------------------------
  const getArticle = word => {
    if (!word) return "";

    const first = word.trim().charAt(0).toLowerCase();
    const vowels = ["a","e","i","o","u"];

    return vowels.includes(first) ? "an" : "a";
  };
  
    // Replace placeholders normally const 
    safeReplace = (html, placeholder, value) => { 
      return html.replace(new RegExp(placeholder, "g"), value); 
    };


    
  // === MAIN TITLE UPDATE ===
  if (elMainTitle) {
    const styleValue = normalize(data.Style);
    const sizeValue = normalize(data.Size);
    const garmentValue = normalize(data.Garment);
    const typeValue = normalize(data.Type); 
    

 let article = getArticle(styleValue);
    let html = elMainTitle.innerHTML;

    // Determine correct word for article
    html = safeReplace(html, "\\[a_an\\]", article);  
   
    html = safeReplace(html, "\\[size\\]", sizeValue);
    html = safeReplace(html, "\\[garment\\]", garmentValue);
    html = safeReplace(html, "\\[type\\]", typeValue);

    // Remove "Length" only when style was continue
    if (String(data.Style).trim().toLowerCase() === "continue") {
        html = safeReplace(html, "\\[style\\]", "");
      html = html.replace(/\bLength\b/gi, "").replace(/\s{2,}/g, " "); 
    } else {
       html = safeReplace(html, "\\[style\\]", styleValue);
    }
  
    
    // if (String(data.Style).toLowerCase() === "continue") { 
    //   html = html.replace(/\bLength\b/gi, "").replace(/\s{2,}/g, " ").trim(); 
    // }
    elMainTitle.innerHTML = html;
  }

  // === YARD TITLE ===
  if (elYardTitle) {
    let html = elYardTitle.innerHTML;
    html = safeReplace(html, "\\[fabric \\(yd\\)\\]", normalize(data["Fabric (yd)"]));
    elYardTitle.innerHTML = html;
  }

  // === YARD BELOW TITLE ===
  if (elYardBelowTitle) {
    let html = elYardBelowTitle.innerHTML;
    html = safeReplace(html, "\\[width\\]", normalize(data["Width (in)"]));
    elYardBelowTitle.innerHTML = html;
  }

  const toHandles = obj => Object.values(obj)
    .filter(v => typeof v === "string" && v.startsWith("/collections/"))
    .map(p => p.split("/collections/")[1].split(/[?#]/)[0].replace(/\/+$/, ""))
    .filter(Boolean);

  const stripHtml = html => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html || "";

    return tmp.textContent.trim();
  };

  const getCollectionInfo = async handle => {
    const colRes = await fetch(`/collections/${handle}?view=fabric-info.json`, {
      headers: { "Accept": "application/json" }
    });
    if (!colRes.ok) return null;

    const colJson = await colRes.json(),
          c = colJson.collection || {};

    const info = {
      title: c.title || handle,
      description: stripHtml(c.description),
      image: c.image?.src || c.image?.url || null,
      url: `/collections/${handle}`
    };

    if (!info.image) {
      const prodRes = await fetch(`/collections/${handle}/products.json?limit=1`, {
        headers: { "Accept": "application/json" }
      });
      if (prodRes.ok) {
        const p = (await prodRes.json()).products?.[0];
        if (p) info.image = p.image?.src || p.image?.url || p.images?.[0]?.src || p.images?.[0]?.url || null;
      }
    }
    return info;
  };

  const renderCard = ({ title, image, url, description }) => {
    const card = document.createElement("div");
    card.className = "collection-card";
    card.innerHTML = `
      <a href="${url}" class="block_fabric-output-collection" style="text-decoration:none;color:inherit;display:block">
        <img src="${image || "https://cdn.shopify.com/s/files/1/0920/6153/2233/files/Frame.png?v=1756874389"}" title="${title}" alt="${title}" loading="lazy">
        <p class="small_body block_output-collection-title" style="margin:0 0 4px;">${title}</p>
      </a>
    `;
    return card;
  };

  if (elCollectionWrapper) {
    const handles = [...new Set(toHandles(data))].slice(0, 5);
    for (const handle of handles) {
      const info = await getCollectionInfo(handle);
      if (info) elCollectionWrapper.appendChild(renderCard(info));
          elCollectionWrapper.closest(".block_output-data").classList.remove("hidden")
    }
  }
});
